import { Component, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  userName = signal<any>('');

  constructor(private router: Router) {
    this.userName.set(localStorage.getItem('userName'));
  }

  onLogout() {
    localStorage.clear();
    this.router.navigate(['/login']);

  }

}
